import React from "react";

const HeroSloganArea = ({ hero }) => {
  return (
    <section
      className="relative w-full overflow-hidden bg-gradient-to-br from-slate-950 via-slate-900 to-slate-800 !m-0 !p-0 block"
    >
      <div className="pointer-events-none absolute inset-0 opacity-40">
        <div className="absolute -left-24 -top-24 h-72 w-72 rounded-full bg-blue-600/40 blur-3xl" />
        <div className="absolute -bottom-24 right-0 h-72 w-72 rounded-full bg-indigo-500/30 blur-3xl" />
      </div>

      <div className="relative min-h-[calc(100vh-64px)] sm:min-h-[calc(100vh-72px)] px-6 pt-16 pb-28 sm:px-10 sm:pt-20 md:px-14 md:pt-24 flex flex-col justify-start text-left">
        <p className="text-[13px] sm:text-[15px] font-bold tracking-widest text-slate-300 uppercase">
          {hero.sloganEn}
        </p>
        <h1 className="mt-4 text-[40px] sm:text-[56px] md:text-[68px] font-black tracking-tight text-white leading-[1.05]">
          {hero.sloganKo}
        </h1>

        <div className="mt-8 h-px w-full max-w-[680px] bg-white/25" />

        <p className="mt-8 max-w-[820px] text-[16px] sm:text-[19px] md:text-[22px] font-medium text-slate-200/90 whitespace-pre-line leading-relaxed">
          {hero.subtitle}
        </p>

        {/* Scroll hint — 섹션 하단 정중앙 고정 */}
        <div className="absolute bottom-8 left-0 right-0 flex flex-col items-center">
          <div className="flex flex-col items-center gap-3 animate-bounce">
            <span className="text-[20px] font-bold tracking-[0.3em] uppercase text-white/70">SCROLL</span>
            <svg
              width="28"
              height="16"
              viewBox="0 0 28 16"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M2 2L14 13L26 2"
                stroke="rgba(255,255,255,0.7)"
                strokeWidth="2.5"
                strokeLinecap="round"
                strokeLinejoin="round"
              />
            </svg>
          </div>
        </div>
      </div>
    </section>
  );
};

export default HeroSloganArea;
